<div id="confirmation-details-section">
    <div *ngIf="showCaseId" class="caseId-container" data-testid="sa-caseId">
        <span id="caseId-label">Case ID: </span>
        <span class="confirmation-detail" id="caseId-value">{{caseId}}</span>
    </div>
    <div class="status-container"  data-testid="sa-status">
        <span id="status-label">Status: </span>
        <span class="confirmation-detail" id="status-value">{{status}}</span>
    </div>
    <div class="timestamp-container"  data-testid="sa-timestamp">
        <span id="timestamp-label">Submitted on: </span>
        <span class="confirmation-detail" id="timestamp-value">
            {{ (useTestTrustDigitalToPdfFlow || isITi401kToAccount) ? dig2PdfDateTime : ((requestedDate$ | async)! | formattedDate) + ' ' + ((requestedTime$ | async)! | formattedTime) }}
        </span>
    </div>
    <div class="source-container"  data-testid="sa-source">
        <span id="source-label">Source: </span>
        <span class="confirmation-detail" id="source-value"> {{ (useTestTrustDigitalToPdfFlow || isITi401kToAccount) ? dig2PdfSource : (source$ | async) }} </span>
    </div>
    <div class="initiatedBy-container"  data-testid="sa-initiatedBy">
        <span id="initiatedBy-label">Initiated by: </span>
        <span class="confirmation-detail" id="initiatedBy-value">{{getInitiatedBy()}}</span>
    </div>
    <div *ngIf="hasReleaseAccess && draftInContext" class="initiatedBy-container" data-testid="sa-releasedBy">
        <span id="releasedBy-label">Released by: </span>
        <span class="confirmation-detail" id="releasedBy-value">{{loginId}}</span>
      </div>
    <div *ngIf="isFromEdit" class="lastModifiedBy-container" data-testid="sa-lastModifiedBy">
      <span id="lastModifiedBy-label">Last Modified By: </span>
      <span class="confirmation-detail" id="lastModifiedBy-value">{{lastModifiedBy}}</span>
    </div>
</div>
